import React from "react";
import { FormattedMessage } from "react-intl";
import CapSelect from "../CapSelect";
import { getCombinedNanoId } from "../CapDnDGraph/utils";
import {
  UPLOAD_LIMIT_EXCEEDED,
  UPLOAD_FAIL,
  EMPTY_CSV_FILE,
  INPROGRESS,
  ENTRY_TRIGGER_EVENT_ATTRIBUTE,
} from "./constants";
import messages from "./messages";
export const handleStoreCodeUpload = (event, payload = {}) => {
  const {
    setShowLoader,
    uploadErrorType,
    setUploadedStores,
    getEntityDetails,
    isStoreFilter,
    onStoreUpload,
    referenceId,
    storeUploadInfo,
    blockId,
    conditionData,
  } = payload;

  const matchingStore = isStoreFilter && storeUploadInfo?.find(
    data => data?.referenceId === referenceId && data?.isStoreRemoved
  );
  // If a matching object is found, generate a new referenceId using nanoid
  const newReferenceId = matchingStore ? getCombinedNanoId(7, 3) : '';
  
  const file = event.target?.files?.[0];
  const fileName = file?.name || "";
  function getAsText(fileToRead) {
    const reader = new FileReader();
    reader.readAsText(fileToRead);
    reader.onload = loadHandler;
    reader.onerror = errorHandler;
  }

  function loadHandler(obj) {
    const csv = obj.target.result;
    processData(csv);
  }

  function processData(csv) {
    const allTextLines = csv.split(/\r\n|\n/);
    const lines = [];
    const initialIndexValue = isStoreFilter ? 0 : 1; // For store_filter there's no header so reading it from 0th index
    for (let i = initialIndexValue; i < allTextLines.length; i++) {
      const data = allTextLines[i].split(",");
      data[0] !== "" && lines.indexOf(data[0]) === -1 && lines.push(data[0]);
    }
    if (lines.length > 0) {
      if (lines.length > 1000 && !isStoreFilter) {
        uploadErrorType(UPLOAD_LIMIT_EXCEEDED);
      } else {
        const reqObjBody = {
          entityIds: lines,
          entity: "store",
          filterAttribute: "code"
        };
        setShowLoader(true);
        if (isStoreFilter) {
          const identifierType = "code";
          const uploadStoreData = [
            {
              fileName,
              uploadStatus: INPROGRESS,
              referenceId,
              newReferenceId,
              blockId,
              s3Path: "",
              identifierType,
              conditionData
            }
          ];
          const storeFilterReqObj = { file };
          onStoreUpload(uploadStoreData, storeFilterReqObj, true);
          setShowLoader(false);
        } else {
          setShowLoader(true);
          getEntityDetails(reqObjBody)
            .then(resData => {
              if (resData.status === 200) {
                const newStores = resData.result.map(storeInfo =>
                  storeInfo.id.toString()
                );
                setUploadedStores(newStores);
                setShowLoader(false);
              } else {
                uploadErrorType(UPLOAD_FAIL);
              }
            })
            .catch(() => {
              setShowLoader(false);
              uploadErrorType(UPLOAD_FAIL);
            });
        }
      }
    } else if (isStoreFilter) {
      return uploadErrorType(EMPTY_CSV_FILE);
    }
  }

  function errorHandler(evt) {
    if (evt.target.error.name === "NotReadableError") {
      console.log(evt.target.error);
    }
  }

  if (window.FileReader) {
    getAsText(event.target.files[0]);
  }
};

export const validateNonEmptyNumberHelper = num => {
  const numPattern = /^-?\d+\.?\d*$/;
  return numPattern.test(num);
};

export const getEventContextComponent = (
  options,
  value,
  handlerFunction,
  eventOptions,
  eventContextData,
  setEventContextData
) => (
  <>
    <CapSelect
      options={options}
      className="event-context-select"
      value={value}
      style={{width: "17.143rem"}}
      onChange={(value) => handlerFunction(value)}
      size="medium"
    />
    {value === ENTRY_TRIGGER_EVENT_ATTRIBUTE && (
      <CapSelect
        options={eventOptions}
        className="event-context-data"
        value={eventContextData}
        placeholder={<FormattedMessage {...messages.selectTriggerEventAttribute} />}
        style={{width: "17.143rem"}}
        onChange={(val) => setEventContextData(val)}
        size="medium"
      />
    )}
  </>
);